'user strict'
const ex = require('../lib/error')
const refVersion = require('../models').refVersion
const sequelize = require('sequelize')
const Op = sequelize.Op
const getRefVersion = (req, res, next) => {
    const where ={is_active:true}
    refVersion
      .findOne({
        where: where})
      .then(version => {
        req.responseObject.messageCode = 'OVA005'
        req.responseObject.data = version
        next()
      })
      .catch(error => {
        let errCode
        errCode = 'OVA006'
        ex.raiseError(req, res, errCode, 500, error)
      })
}
const addVersion =(req, res, next) => {
  refVersion
    .create(req.body)
    .then(version => {
      req.responseObject.messageCode = 'MAUD001'
      req.responseObject.data = version
      next()
    })
    .catch(error => {
      let errCode
      if (error.name === 'SequelizeUniqueConstraintError') {
        errCode = 'MAUD003'
      } else {
        errCode = 'MAUD004'
      }
      ex.raiseError(req, res, errCode, 500, error)
    })
}

const updateVersion = (req, res, next) => {
  refVersion
  .update(req.body, {
    where: { id: req.params.id },
    returning: true
  })
  .then(version => {
    req.responseObject.data =  version
    next()
  })
  .catch(error => {
    ex.raiseError(req, res, 'OVA008', 500, error)
  })
}


module.exports = {
    getRefVersion,
    addVersion,
    updateVersion,
}